'use strict';
namespace TR {
    export class ContactFormPopUp {
        iframeUrl: string;
        buttonText: string;

        constructor(
            private accountMenuService: any,
            private authService: any,
            private resourceService: Core.ResourceService
        )
        {}

        public isUrl() {
            let regexp = new RegExp('^http'),
                test = regexp.test(this.iframeUrl);
            return test;
        }

        public popupSignIn = (event) => {
            event.preventDefault();
            this.authService.bufferRoute(null);
            this.accountMenuService.launchContactForm('contactformpopup');
        }
    }

    angular
        .module('TR')
        .directive('contactFormpopup', (): ng.IDirective => {
            return {
                bindToController: {
                    iframeUrl: '@',
                    buttonText: '@'
                },
                controller: ContactFormPopUp,
                controllerAs: 'cfpu',
                restrict: 'E',
                replace: true,
                template: `
                    <a ng-if="cfpu.isUrl()" href="#"
                        ng-click="cfpu.popupSignIn($event)"
                        class="button primary myb-primary-btn myb-details-btns">{{::cfpu.buttonText}}</a>`,
                transclude: false
            };
        });
}
